@use '@lib/assets/styles/main.scss' as *;
.message {
  margin-bottom: 8px;
  margin-top: -8px;
}

.pagination {
  background-color: $gray0;
}

.tasksGrid {
  & > * + * {
    margin-top: 16px;
  }
}
